import UserInputAcknowledgementDesktop from "../components/desktop/user-input-acknowledgement/UserInputAcknowledgementDesktop";

const UserInputAcknowledgement = () => {
  return (
    <>
      <UserInputAcknowledgementDesktop />
    </>
  );
};

export default UserInputAcknowledgement;
